<template>
  <div class="container">
    <div class="searchBox">
      <el-form ref="search_data" :model="search_data" size="medium">
        <div style="display: flex;">
          <el-form-item label="订单状态" label-width="150px">
            <el-select
              v-model="search_data.status"
              placeholder="请选择订单状态"
              clearable
              style="width: 200px"
            >
              <el-option
                v-for="(item, index) in status_select"
                :key="index"
                :label="item"
                :value="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="核销状态" label-width="150px">
            <el-select
              v-model="search_data.hx_status"
              placeholder="请选择核销状态"
              clearable
              style="width: 200px"
            >
              <el-option
                v-for="(item, index) in hx_status_select"
                :key="index"
                :label="item"
                :value="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间" label-width="150px">
            <el-date-picker
              v-model="time"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
        </div>
        <div>
          <el-form-item label-width="150px">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="searchorderLists"
              >搜索</el-button
            >
            <el-button icon="el-icon-refresh-right" @click="refresh"
              >刷新</el-button>

          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="searchInfo">
      <div>
        <!-- 表格 -->
        <el-table
          border
          :data="tableData"
          style="width: 100%"
          ref="multipleTable"
          header-cell-class-name="table-header"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="index" label="序号" width="50" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }} <!-- 基础序号 -->
            </template>
          </el-table-column>

          <el-table-column prop="order_id" label="抖音订单号" align="center"></el-table-column>

          <el-table-column prop="order_code" label="九州订单号" align="center"></el-table-column>

          <el-table-column prop="product_id" label="商品id" align="center"></el-table-column>

          <el-table-column prop="book_id" label="核销id" align="center"></el-table-column>

          <el-table-column label="订单状态" align="center" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">待支付</span>
              <span v-if="scope.row.status == 1">未预约</span>
              <span v-if="scope.row.status == 2">已预约</span>
              <span v-if="scope.row.status == 3">已完成</span>
              <span v-if="scope.row.status == 4">已关闭</span>
            </template>
          </el-table-column>

          <el-table-column prop="total_amount" label="支付金额" align="center" width="100"></el-table-column>

          <el-table-column prop="all_amount" label="订单金额包括加价" align="center" width="100"></el-table-column>

          <el-table-column prop="fee_list" label="费用明细" align="center"></el-table-column>

          <el-table-column label="加价状态" align="center" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.price_increase_type == 0">不需要加价</span>
              <span v-if="scope.row.price_increase_type == 1">加价</span>
              <span v-if="scope.row.price_increase_type == 2">加价支付</span>
            </template>
          </el-table-column>

          <el-table-column prop="price_increase" label="加价金额" align="center" width="100"></el-table-column>

          <el-table-column label="核销状态" align="center" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.hx_status == 0">待核销</span>
              <span v-if="scope.row.hx_status == 1">核销成功</span>
              <span v-if="scope.row.hx_status == 2">核销失败</span>
            </template>
          </el-table-column>

          <el-table-column prop="hx_json" label="核销结果json" align="center"></el-table-column>


          <el-table-column
            label="操作"
            align="center"
            width="100"
          >
            <template slot-scope="scope" v-if="scope.row.hx_status == 2">
              <el-button type="primary" size="mini" @click="pushOrder(scope.row)">推送核销</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页组件 -->
      <div class="pagination">
        <pages
          :search_data="search_data"
          :result_data="result_data"
          @pages_function="pages_function"
        ></pages>
      </div>
    </div>
  </div>
</template>

<script>
var _this;
import bus from "@/utils/bus.js";
export default {
  components: {
  },

  data() {
    return {
      addGroup_show: false,
      editGroup_show: false,
      editGroup_data: {},

      loading: false,

      status_select: ['待支付','未预约', '已预约 ','已完成','已关闭'],
      hx_status_select: ['待核销','核销成功 ', '核销失败'],

      company_name: "",

      search_time: "",
      end_time: "",
      time: "",

      submit_data: {
        page: 1,
        city_code: JSON.parse(localStorage.getItem('login')).city.city_code,
        city_tag: localStorage.getItem("city_tag"),
        status: "",
        hx_status: "",
        start_time: "",
        end_time: "",
      },

      excelData: [],

      excelHead: [],

      // 存放表格数据
      tableData: [],

      //翻页数据
      search_data: {
        page: 1,
        limit: 10,
        hx_status: "",
        city_code: JSON.parse(localStorage.getItem('login')).city.city_code,
        city_tag: localStorage.getItem("city_tag"),
        status: "",
        start_time: "",
        end_time: "",
      },

      result_data: [],
      search_rules: {
        page: {
          placeholder: "页码",
          rules: {
            required: true,
            message: "页码需要大于0",
            regulation: "gt",
            rulesData: 0,
          },
        },
        limit: {
          placeholder: "每页个数",
          rules: {
            required: true,
            message: "每页个数需在1-51之内",
            regulation: "between",
            rulesData: [1, 51],
          },
        },
      },
    };
  },
  created() {
    _this = this;
    _this.orderLists();
  },
  beforeDestroy() {
    bus.$off("getCity");
  },
  mounted() {
    // 通过 Event Bus
    bus.$on("getCity", (msg) => {
      _this.search_data.city_code = JSON.parse(localStorage.getItem('login')).city.city_code;
      _this.search_data.city_tag = localStorage.getItem("city_tag")

      _this.submit_data.city_code = JSON.parse(localStorage.getItem('login')).city.city_code;
      _this.submit_data.city_tag = localStorage.getItem("city_tag")
    });
  },
  methods: {
    // 推送订单
    pushOrder(row) {
      _this
        .$post("/douyin/pushDelivery", {
          book_id: row.book_id,
        })
        .then((res) => {
          _this.$message.success(res.msg);
          //初始化显示列表
          _this.orderLists();
        })
        .catch((err) => {});
    },
    timeChange(val) {
      if (val != null) {
        _this.search_data.start_time = val[0];
        _this.search_data.end_time = val[1];
      } else {
        _this.search_data.time_fixed = "";
      }
    },
    searchorderLists() {
      _this.search_data.page = 1;
      _this.search_data.city_tag = localStorage.getItem("city_tag")
      _this.orderLists();
    },
    // 搜索司机日志列表
    orderLists() {
      _this
        .$post("/douyin/orderListQuery", _this.search_data, _this.search_rules)
        .then((res) => {
          // 将请求的数据存放到表格数据数组中
          console.log(res);
          _this.tableData = res.data.getLists_.result;
          _this.result_data = res.data.getLists_;
          console.log('tableData',_this.tableData);
        })
        .catch((err) => {});
    },
    //翻页组件的回调
    pages_function(search_data) {
      //赋值
      _this.search_data = search_data;
      //初始化列表
      _this.orderLists();
    },

    handleSelectionChange(val) {
      var datalist = [];

      for (var i in val) {
        datalist.push(val[i].driver_code);
      }
      _this.delDriverSubmit_data.driver_code_array = datalist;
    },
    // 刷新按钮
    refresh() {
      this.$router.go(0);
    },
  },
};
</script>

<style scoped>
</style>